/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface V1SleepAction
 */
export interface V1SleepAction {
    /**
     * Seconds is the number of seconds to sleep.
     * @type {number}
     * @memberof V1SleepAction
     */
    seconds?: number;
}

export function V1SleepActionFromJSON(json: any): V1SleepAction {
    return V1SleepActionFromJSONTyped(json, false);
}

export function V1SleepActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1SleepAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'seconds': !exists(json, 'seconds') ? undefined : json['seconds'],
    };
}

export function V1SleepActionToJSON(value?: V1SleepAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'seconds': value.seconds,
    };
}

